import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'veggieTheme',
    themes: {
      veggieTheme: {
        dark: false,
        colors: {
          primary: '#4CAF50',      // Verde natural
          secondary: '#FF9800',    // Naranja energético
          accent: '#8BC34A',       // Verde claro
          error: '#F44336',
          warning: '#FFC107',
          info: '#2196F3',
          success: '#4CAF50',
          background: '#FAFAFA',
          surface: '#FFFFFF',
          'primary-darken': '#388E3C',
          'secondary-darken': '#F57C00',
        }
      }
    }
  }
});